import type { ThemeMode } from "@superblocksteam/shared";
import type { GeneratedTheme, UserAccessibleTheme } from "legacy/themes/types";
import type { AppState } from "store/types";

export const selectGeneratedTheme = (_state: AppState): GeneratedTheme => {
  throw new Error("selectGeneratedTheme is not available in dashboard");
};

export const selectOverrideThemeMode = (
  _state: AppState,
): ThemeMode | undefined => undefined;

export const getUserAvailableTheme = (
  _state: AppState,
): UserAccessibleTheme => {
  throw new Error("getUserAvailableTheme is not available in dashboard");
};
